module.exports = __webpack_public_path__ + "static/media/mom+stroller-FINAL@2x.b1b3cf36.png";